export const Brands = () => (
  <div id="brands" className="brands-section">
    <div className="container">
      <div className="section-title">
        <h2>Our Brands</h2>
        <p>Netra Bharat Industries operates as the parent company powering two distinct brands for different markets.</p>
      </div>

      <div className="brand-parent-box">
        <div className="brand-parent-logo">
          <img src="https://res.cloudinary.com/dbgzzcwvr/image/upload/v1756632676/icon_xqzodb.png" alt="NBI" />
        </div>
        <div className="brand-parent-text">
          <h3>Netra Bharat Industries Pvt. Ltd.</h3>
          <p>Parent Company · Consumer Products · Brand Development · Distribution</p>
        </div>
      </div>

      <div className="brand-hierarchy-arrow"><i className="fa fa-chevron-down"></i></div>

      <div className="row brands-row">
        <div className="col-md-6">
          <div className="brand-card brand-utensy">
            <div className="brand-badge">Active</div>
            <div className="brand-type-label" style={{color:"#8B1A1A"}}>B2B Supply & Wholesale Division</div>
            <img src="https://res.cloudinary.com/dbgzzcwvr/image/upload/v1783339832/Logo_gdnb7m.png" alt="Utensy" className="brand-logo" />
            <h3>Utensy</h3>
            <p className="brand-tagline">Healthy Cooking</p>
            <p className="brand-desc">Our B2B supply brand — cookware, pressure cookers and gas stoves supplied to dealers, distributors, OEM partners and export buyers across India and international markets including Nepal.</p>
            <ul className="brand-points">
              <li><i className="fa fa-check"></i> Dealers & Distributors</li>
              <li><i className="fa fa-check"></i> OEM & Bulk Orders</li>
              <li><i className="fa fa-check"></i> Export Supply — Nepal & More</li>
            </ul>
            <a href="#contact" className="btn btn-custom page-scroll">Enquire Now</a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="brand-card brand-mrutensy">
            <div className="brand-badge coming-soon">Coming Soon</div>
            <div className="brand-type-label">Primary Consumer Brand (D2C)</div>
            <div className="mrutensy-logo-wrap">
              <span className="mrutensy-logo-text">Mr<span>Utensy</span></span>
            </div>
            <h3>MrUtensy</h3>
            <p className="brand-tagline">For Every Indian Home</p>
            <p className="brand-desc">Our primary D2C consumer brand — bringing quality cookware and kitchen products directly to consumers via Amazon, Flipkart and our own online store.</p>
            <ul className="brand-points">
              <li><i className="fa fa-check"></i> Amazon & Flipkart</li>
              <li><i className="fa fa-check"></i> Direct-to-Consumer</li>
              <li><i className="fa fa-check"></i> Retail & E-commerce</li>
            </ul>
            <div className="coming-soon-tag"><i className="fa fa-clock-o"></i> Launching Soon</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
